{
  "actions": "Dejanja",
  "hideButtonLabel": "Prikaži manj",
  "showAllButtonLabel": "Prikaž vse ({tagCount, number})"
}
